document.addEventListener('DOMContentLoaded', () => {
    const openMenuMobile = document.getElementById('open-menu-mobile');
    const menuMobile = document.getElementById('menu-mobile');
    const header = document.querySelector('.container-items-menu');

    openMenuMobile.addEventListener('click', () => {
        menuMobile.classList.toggle('open');
        openMenuMobile.classList.toggle('active');
    });

    window.addEventListener('scroll', () => {
        header.classList.toggle('scrolled', window.scrollY > 0);
    });
});